import { memo, useContext } from 'react';
import { MediaPlaybackTimeContext } from '../../context/MediaPlaybackTimeContext';
import { MediaPlayerTime } from './MediaPlayerTime';
import { jsx as _jsx } from "react/jsx-runtime";
const __MediaPlayerCurrentTime = () => {
  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const currentTime = useContext(MediaPlaybackTimeContext);
  return /*#__PURE__*/_jsx(MediaPlayerTime, {
    time: currentTime,
    textAlign: "start"
  });
};
export const MediaPlayerCurrentTime = /*#__PURE__*/memo(__MediaPlayerCurrentTime);